var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "category-item__quick-view-qty-wrapper" }, [
    _vm.view != "checkout"
      ? _c("div", { staticClass: "category-item__quick-view-qty-txt" }, [
          _vm._v(_vm._s(_vm.$translate("ODStylebreaker::Template.amount")))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "qty-box d-flex" }, [
      _c(
        "button",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: _vm.isMinimum,
              expression: "isMinimum"
            }
          ],
          staticClass:
            "btn qty-btn flex-fill d-flex justify-content-center p-0",
          class: { disabled: _vm.isMinimum || _vm.waiting },
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "bottom",
            title: _vm.minimumHint,
            "data-testing": "quantity-btn-decrease"
          },
          on: {
            click: function($event) {
              return _vm.decreaseValue()
            }
          }
        },
        [
          _c("i", {
            staticClass: "fa fa-minus default-float",
            attrs: { "aria-hidden": "true" }
          })
        ]
      ),
      _vm._v(" "),
      _c("input", {
        ref: "quantityInputField",
        staticClass: "qty-input text-center",
        class: { "add-border-right": _vm.view == "checkout" },
        attrs: {
          type: "text",
          disabled: _vm.waiting,
          "aria-label": _vm.$translate("Ceres::Template.itemQuantityInput")
        },
        domProps: { value: _vm.displayValue },
        on: {
          change: function($event) {
            return _vm.setValue($event.target.value)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: _vm.isMaximum && _vm.compMax !== 0,
              expression: "isMaximum && compMax !== 0"
            }
          ],
          staticClass:
            "btn qty-btn flex-fill d-flex justify-content-center p-0",
          class: { disabled: _vm.isMaximum || _vm.waiting },
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            title: _vm.maximumHint,
            "data-testing": "quantity-btn-increase"
          },
          on: {
            click: function($event) {
              return _vm.increaseValue()
            }
          }
        },
        [
          _c("i", {
            staticClass: "fa fa-plus default-float",
            attrs: { "aria-hidden": "true" }
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }